import { StorageWrapper } from "./storageWrapper";

const lastConnected = new StorageWrapper("gsw-last");
export default lastConnected;
